<script>
    import Sidebar from "../_sidebar/index.svelte";
    import logService from "./service.js";
    import BreadCrumNav from "../../components/breadcrum-nav.svelte";
    import LogList from "../../components/list.svelte";
    import { format, locale } from "svelte-i18n";
    import dayjs from "dayjs";
    import relativeTime from "dayjs/plugin/relativeTime";
    import localizedFormat from "dayjs/plugin/localizedFormat";
    import "dayjs/locale/es";
    import "dayjs/locale/en";

    dayjs.locale($locale);
    dayjs.extend(relativeTime);
    dayjs.extend(localizedFormat);

    const logColumnsDef = [
        { key: "date", title: $format("list.columns.date"), filterable: false },
        { key: "time", title: $format("list.columns.hour"), filterable: false },
        {
            key: "target_object_type",
            title: $format("list.columns.type"),
            filterable: false,
        },
        {
            key: "source_user_name",
            title: $format("list.columns.user"),
            filterable: false,
        },
        {
            key: "event_id",
            title: $format("list.columns.event"),
            filterable: false,
        },
        {
            key: "target_object_name",
            title: $format("list.columns.data"),
            filterable: false,
        },
        {
            key: "event_data",
            title: $format("list.columns.resource"),
            filterable: false,
        },
    ];

    const translateEventId = (value) => {
        if ($locale != "es") return;
        if (!value) return "";

        const labels = {
            finding: "Hallazgo",
            service: "Servicio",
            certificate: "Certificado",
            product: "Producto",
            user: "Usuario",
            network: "Red",
            domain: "Dominio",
            cloud: "Cuenta cloud",
            ip: "IP",
            Document: "Documento",
            document: "Documento",
            "asset.public_ip": "IP",
            "asset.private_ip": "IP",
            "asset.public_network": "Red",
            "asset.private_network": "Red",
            "asset.finding": "Hallazgo",
            "asset.certificate": "Certificado",
            "asset.domain": "Dominio",
            "asset.ad": "Active Directory",
            "asset.software": "Código fuente",
            "asset.endpoint": "Endpoint",
            "asset.other": "Otros activos",
            "asset.cloud": "Cuenta Cloud",
            "asset.hostname": "Hostname",
        };

        let regex = new RegExp(value, "gi");

        if (value.includes("token.create")) value = "Inicio de sesión";
        else if (value.includes("token.delete")) value = "Cierre de sesión";
        else if (value.includes("password"))
            value = value.replace("password", "Contraseña");
        else if (value.includes("otac")) value = value.replace("otac", "OTAC");
        else if (value.includes(".create")) value = "Creación";
        else if (value.includes(".delete")) value = "Eliminación";
        else if (value.includes("document.processed"))
            value = "Documento procesado";
        else if (value.includes("finding.open")) value = "Hallazgo abierto";
        else if (value.includes("update")) value = "Actualización";
        else if (value.includes("Property")) value = "Propiedad";
        else if (value.match(regex))
            value = value.replace(regex, labels[value.toLowerCase(2)]);

        if (value === "undefined") value = "";

        return value;
    };

    let logs = [];
    // logs filtered by dataTables
    let logsFiltered = [];

    let logsPromise = $state(
        logService.search().then((pLogs) => {
            pLogs.forEach((log, i) => {
                let timestamp = dayjs(log.timestamp).format().split("T");
                let time = timestamp[1].split("-");
                log.date = dayjs(timestamp[0]).format("YYYY-MM-DD");
                log.time = time[0];

                if (log.target_object_name.length > 40) {
                    log.long_target_object_name =
                        log.target_object_name.split(",");
                }
            });
            logs = parseLogsFunc(pLogs);
            return { logs: logs };
        }),
    );
    /** refresh table
     *
     * @param forceRefresh: true | false
     */
    const handleTableRefresh = (config) => {
        logsPromise = logService.search(config).then((pLogs) => {
            pLogs.forEach((log) => {
                let timestamp = dayjs(log.timestamp).format().split("T");
                let time = timestamp[1].split("-");
                log.date = timestamp[0];
                log.time = time[0];

                if (log.target_object_name.length > 40) {
                    log.long_target_object_name =
                        log.target_object_name.split(",");
                }
            });
            logs = parseLogsFunc(pLogs);
            return { logs: logs };
        });
    };
    const parseLogsFunc = (pageContent) => {
        pageContent.forEach((row, i) => {
            if (row["target_object_type"]) {
                row["target_object_type"] =
                    translateEventId(row.target_object_type) ||
                    row.target_object_type;
            }
            if (row["source_user_name"]) {
                row["source_user_name"] = row.source_user_name.includes(
                    "@internal.vulseek.io",
                )
                    ? $format("page.log.system_user")
                    : row.source_user_name;
            }
            if (row["event_id"]) {
                row["event_id"] =
                    translateEventId(row.event_id) || row.event_id;
            }
            if (row["target_object_name"]) {
                if (
                    !row["target_object_name"].includes("cpe") &&
                    row["target_object_name"].includes(":")
                ) {
                    let long_name = row.target_object_name.split(":");
                    row.target_object_name =
                        long_name[0] + " - " + long_name[1];
                }
            }
            if (row["event_data"]) {
                if (
                    row["event_data"].method &&
                    row["event_data"].method == "password"
                ) {
                    row["event_data"] = "Contraseña";
                } else if (row["event_data"].key && !row["event_data"].method) {
                    row["event_data"] = "";
                } else if (
                    row["event_data"].to_asset_id &&
                    row["event_data"].from_asset_id
                ) {
                    row.event_data = "Activo relacionado";
                } else if (row["event_data"].status) {
                    let new_status = row.event_data.status.split(".")[1];
                    row["event_data"] =
                        `${$format("page.log.status_change")} ${$format(`finding.status.${new_status}`)}`;
                } else if (row["event_data"].in_scope) {
                    row["event_data"] = $format(
                        `page.log.scope_${row.event_data.in_scope}`,
                    );
                } else {
                    let eventKeys = Object.keys(row["event_data"]);
                    if (row.event_id && row.event_id == "Creación") {
                        row.event_data = row["event_data"].name
                            ? "Nombre: " + row["event_data"].name
                            : "";
                    } else {
                        row["event_data"] = eventKeys.join(", ");
                    }
                }
            }
        });
        return pageContent;
    };
</script>

<section class="content-header">
    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
                <h1 class="mt-3 mb-3 page-title">
                    <i class="fas fa-align-justify fa-xs"></i>
                    Logs
                </h1>
            </div>
            <div class="col-6">
                <BreadCrumNav routes={[{ label: "Logs" }]} />
            </div>
        </div>
        <small>{$format("page.log.label")}</small>
    </div>
</section>

{#await logsPromise then data}
    <section class="content">
        <div class="container-fluid">
            <div class="card">
                <div class="card-header">
                    <div class="card-tools float-end">
                        <button
                            class="btn btn-secondary table-button btn-refresh btn-xs t-refresh-log-btn"
                            tabindex="0"
                            aria-controls="logTable"
                            type="button"
                            title={$format("buttons.refresh")}
                            id="logRefreshBtn"
                            onclick={handleTableRefresh}
                            ><i class="fa fa-sync-alt"></i></button
                        >
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <LogList
                            data={data.logs}
                            instructs={logColumnsDef}
                            parseFunc={parseLogsFunc}
                            prefix={"logTable"}
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
{/await}
{#await logsPromise}
    <div class="overlay text-center">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
    </div>
{/await}
